import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=2d1e87ea&"
import script from "./wait.vue?vue&type=script&lang=js&"
export * from "./wait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports